module.exports = __webpack_public_path__ + "static/media/x-trail-side.157344c6.webp";